import { Command } from 'commander'
import pc from 'picocolors'
import { loadConfig } from '../../config'

export const devCommand = new Command('dev')
  .description('Start development preview (guidance for local setup)')
  .option('-p, --port <port>', 'Port number', '3000')
  .action(async (options: { port: string }) => {
    const cwd = process.cwd()

    // Load config
    const config = await loadConfig(cwd)
    const slug = config?.presentation.slug || 'my-presentation'
    const port = options.port || config?.dev?.port?.toString() || '3000'

    console.log(pc.cyan('\nBrixon Development Preview'))
    console.log(pc.dim('─'.repeat(40)))

    console.log(pc.white(`
For local preview, the recommended workflow is:

${pc.bold('1. Start Next.js dev server:')}
   ${pc.green('npx next dev -p ' + port)}

${pc.bold('2. View your presentation:')}
   ${pc.blue('http://localhost:' + port + '/p/' + slug)}

${pc.bold('3. Edit your presentation:')}
   ${pc.dim('src/presentation.tsx')}
`))

    console.log(pc.dim('─'.repeat(40)))
    console.log(pc.dim('Note: Full HMR dev server coming in future version.'))
    console.log(pc.dim('For now, use Next.js directly for the best experience.'))
  })
